import React from 'react';
import { withStyles, StyledComponentProps } from '@material-ui/core';
import { styles } from './styles';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import moment from 'moment';
import MomentUtils from '@date-io/moment';
import "moment/locale/it";
require('moment/locale/it.js');


interface IProps extends StyledComponentProps {
    label?: string;
    value: Date;
    onChange?: (val: Date) => any;
    placeholder?: string;
    disabled?: boolean;
    key: string;
    fullWidth?: boolean;
    minDate?: Date;
    clearable?: boolean;
}

// const handleMouseDown = (event: React.MouseEvent<HTMLButtonElement>) => {
//     event.preventDefault();
// };

const TextField = (props: IProps) => {
    // const { classes, ...otherProps } = props;
    // const { text, label, clearIcon, ...otherClasses } = classes;
    const onChange = (e) => {
        props.onChange(e ? e.toDate() : undefined)
    };
    // var _clearable = false;
    // if (props.clearable !== undefined) {
    //     _clearable = props.clearable;
    // }
    return (
        // style={{ backgroundColor: 'green', color: 'white', textIndent: '20px' }}
        <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale={moment.locale("it")}>
            <KeyboardDatePicker
                key={props.key}
                fullWidth={props.fullWidth}
                disableToolbar
                disabled={props.disabled}
                placeholder={props.placeholder}
                autoOk
                // clearable={_clearable}
                minDate={props.minDate}
                variant="inline"
                color="secondary"
                format="DD-MM-yyyy"
                margin="normal"
                id="date-picker-inline"
                label={props.label}
                value={props.value}
                onChange={onChange}
                KeyboardButtonProps={{
                    'aria-label': 'change date',
                }}
            />
        </MuiPickersUtilsProvider>
    );
}

export default withStyles(styles)(TextField);